import React from "react";
import "../../App.css";

export default function Products() {
  return <h1 className="Products">PRODUCTS</h1>;
}
